var _ellipse, _path, _ellipse2, _ellipse3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 31,
    viewBox: "0 0 54 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0002,
    cy: 8,
    rx: 7,
    ry: 8,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 27C40.0002 31.4183 34.1799 30 27.0002 30C19.8205 30 14.0002 31.4183 14.0002 27C14.0002 22.5817 19.8205 17 27.0002 17C34.1799 17 40.0002 22.5817 40.0002 27Z",
    fill: "#404040"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5002,
    cy: 7,
    rx: 5.5,
    ry: 6,
    fill: "#404040"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5002,
    cy: 7,
    rx: 5.5,
    ry: 6,
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2559 17.1207C52.4179 20.371 51.365 23.4536 46.6846 25.1269C42.0041 26.8002 42.5308 23.9058 41.3687 20.6555C40.2067 17.4052 33.0878 16.7131 37.7683 15.0398C42.4487 13.3665 50.0939 13.8704 51.2559 17.1207Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01998 17.1207C0.857949 20.371 1.91085 23.4536 6.59129 25.1269C11.2717 26.8002 10.7451 23.9058 11.9071 20.6555C13.0692 17.4052 20.188 16.7131 15.5076 15.0398C10.8272 13.3665 3.182 13.8704 2.01998 17.1207Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.598a4d26b1c3d3c4973e79a0c2ce4daa.svg";
export { ForwardRef as ReactComponent };